import React from 'react';
import { Package } from 'lucide-react';
import { useBranding } from '../context/BrandingContext';

export default function BrandLogo({ size = 56, radius = 16, fallbackIcon: FallbackIcon = Package }) {
  const { branding } = useBranding();
  const iconSrc = branding.faviconImage;

  return (
    <div
      className={`brand-logo-mark ${iconSrc ? 'has-uploaded-logo' : ''}`}
      style={{ width: size, height: size, borderRadius: radius }}
    >
      {iconSrc ? (
        <img src={iconSrc} alt={branding.appName || 'Material Stock'} />
      ) : (
        <FallbackIcon size={Math.round(size * 0.45)} color="white" />
      )}
    </div>
  );
}
